// Profile details fields
export enum FieldType {
  FullName = 'fullName',
  Nickname = 'nickname', // aka `Public name`
  Title = 'title',
  Department = 'department',
  CompanyName = 'companyName',
  Location = 'location',
  Timezone = 'timezone',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Avatar = 'picture',
  Language = 'language',
  LocalTime = 'localTime',
}
